export default __webpack_public_path__ + "static/media/partnerLogo.0782ab5d.svg";